// extracted by mini-css-extract-plugin
module.exports = {"faq__title":"Faq_faq__title__04mYi","faq__item":"Faq_faq__item__qF0uP"};